export enum AppFeatureExtensions {
  ASSOCIATION_DIRECT_APPLICANT = 'association-direct-applicant',
  ASSOCIATION_FORWARD_ONLY = 'association-forward-only',
  ASSOCIATION_ENABLE_MULTI_REASON_SELECTION = 'association-enable-multi-reason-selection',
  ASSOCIATION_CONFIGURATIONS_PER_JOB = 'association-configurations-per-job',
  DUPLICATE_CANDIDATE_NOTIFICATION = 'duplicate-candidate-notification',
  REFERRAL_NOTIFICATION = 'referral_notification',
  REFERRAL_EXTENDED = 'referral-extended',
  EXTERNAL_SYSTEM_INFORMATION = 'additional-information-from-external-system',
  FMI_INVITE_TO_APPLY = 'fmi-invite-to-apply',
  PROSPECT = 'prospect',
  ORACLE_REFRESH_JOB = 'oracle-refresh-job',
  GREENHOUSE_ATS = 'greenhouse',
  JOB_BOARDS = 'job-boards',
  JOB_STATUSES_ALL = 'all-job-statuses',
  JOB_STATUSES_BASIC = 'basic-job-statuses',
  NOTES_SINGLE_TAB = 'single-tab-notes',
  CANDIDATES_HIRING_MANAGER_NOTES = 'candidates-hiring-manager-notes',
  CANDIDATES_RECRUITER_NOTES = 'candidates-recruiter-notes',
  JOBS_RECRUITER_NOTES = 'jobs-recruiter-notes',
  JOBS_HIRING_MANAGER_NOTES = 'jobs-hiring-manager-notes',
  ORACLE_ATS = 'hcm',
  HIRING_MANAGER_FLOW = 'hiring-manager-flow',
  SAML_AUTHENTICATION = 'saml-authentication',
  USER_MANAGEMENT = 'user-management',
  CHANGE_PHASE_ON_REJECTED_STATE = 'change-phase-on-rejected',
  ASSOCIATION_EMAIL_TEMPLATES = 'association-email-templates',
  JOB_BOARD_SETTINGS_FMI_CONFIGURATION = 'job-board-settings-fmi-configuration',
  REFERRAL_REPORT = 'referral-report',
  TALENT_POOLS = 'talent-pools-view',
  ADD_TALENT = 'add-talent',
  REFERRAL_WHOLE_FLOW = 'referral-whole-flow',
  DASHBOARD_DISPLAY_OFFER = 'dashboard-display-offer',
  ALUMNI_BADGE = 'alumni-badge',
  TASKS = 'tasks',
  API_KEY = 'api-key',
  DISPLAY_COVER_LETTER_FILES = 'display-cover-letter-files',
  POOLS_SYNCHRONIZATION = 'prospect-pools-ats-synchronization',
  ENABLE_EMAIL_BY_DEFAULT = 'enable-email-by-default',
  IRP_PBI_REPORT = 'irp-pbi-report',
  PBI_REPORTS_WITH_OTHER_MENU_ITEMS = 'pbi-reports-with-other-menu-items',
  JOB_DEFAULT_DESCRIPTION = 'job-default-description',
  NLS_SEARCH = 'nls-search',
  CONVERSION_AND_ROI_REPORT = 'conversion-roi-report',
  USAGE_REPORT = 'usage-report',
  PROJECTS_REPORT = 'projects-report',
}

export type JobFilterExtensions =
  | AppFeatureExtensions.JOB_STATUSES_BASIC
  | AppFeatureExtensions.JOB_STATUSES_ALL;
